export default {
    namespaced: true, // 使用namespaced确保模块的state、mutations、actions和getters是命名空间化的
  
    state() {
      return {
        detailShow: false, //详情面板
        detailContent: {}, //详情信息
      };
    },
  
    mutations: {
      SET_DS(state, detailShow) {
        state.detailShow = detailShow
      },
      SET_DC(state, detailContent) {
        state.detailContent = detailContent
      }
    },
  
    actions: {
      // 其他actions...
    },
  
    getters: {
      detailShow: (state) => state.detailShow,
      detailContent: (state) => state.detailContent,
      // 其他getters...
    },
  };
  